import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { StructuredContentDocument } from '../../hydration/types';
type SPACING = [0, 1, 2, 3, '3-half', 4, 5];
type SpacerProps = StructuredContentDocument<{
  spacing: SPACING[number];
}>;
export const Spacer = t0 => {
  const $ = _c(2);
  const {
    props
  } = t0;
  const {
    spacing
  } = props;
  let t1;
  if ($[0] !== spacing) {
    t1 = <Box sx={{
      marginBottom: spacing
    }} />;
    $[0] = spacing;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};